import type { Site } from '../Site';

export const PricePandaSG: Site = {
  id: 'pricepandasg',
  logo: '',
  label: 'PricePanda SG',
  analyticsName: 'pricepandasg',
  hostname: 'pricepanda.com.sg',
  platform: 'responsive',
  selector: 'main a',
};
